
































































import { Component, Prop, Vue, Ref } from 'vue-property-decorator';
import http from '@/services/Http';
type TAuthResponse = {
    success: boolean;
    meetingId: string;
    autoStartToken: string;
    autoStartUrl: string;
    qrImage?: string;
};
type TPollResponse = {
    meetingId: string;
    errorMessage: string;
    status: 'complete' | 'failed' | 'pending';
    person: string;
};
@Component
export default class IdentityVerification extends Vue {
    @Prop() bookingId!: string;
    @Prop() culture!: string;
    @Ref('idContainer') idContainer!: HTMLDivElement;
    [x: string]: any;
    qrCodePath: string = '';
    qrTimeStamp: number = 1;
    qrInProgress: boolean = false;
    pollCollect: boolean = false;
    showError: boolean = false;
    organizationId: string = '';
    authData: TAuthResponse = {
        success: false,
        meetingId: '',
        autoStartToken: '',
        autoStartUrl: '',
        qrImage: ''
    };
    mounted() {
        //window.scrollTo({ top: 0, behavior: 'smooth' });
        /*const element = document.getElementById('meeting-container');
        if (element) {
            
        }*/
        this.idContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });
        this.organizationId = this.$route.query.retailer as string;
        //If meetingId and orderRef exists we complete ID verification
        if (typeof this.$route.query.meetingId !== 'undefined') {
            this.authData.meetingId = this.$route.query.meetingId as string;
            this.pollCollect = true;
            this.pollCollectRequest(true);
        }
    }
    submitId(getQr: boolean) {
        const payload = {
            meetingId: this.bookingId,
            organizationId: this.organizationId,
            getQr: getQr,
            redirectUrl: this.returnUrl
        };
        this.showError = false;
        const bookMeeting = http.post('/api/bankid/auth', payload);
        bookMeeting
            .then((response: any) => {
                response.json().then((data: TAuthResponse) => {
                    this.authData = data;
                    if (getQr) {
                        this.otherDeviceAuth();
                    } else {
                        this.sameDeviceAuth();
                    }
                });
            })
            .catch((e: any) => {
                console.error(e);
            });
    }

    sameDeviceAuth() {
        let bankIdLink = `bankid:///?autostarttoken=${this.authData.autoStartToken}&redirect=${encodeURIComponent(
            this.returnUrl
        )}`;
        if (this.culture === 'nb-NO') {
            bankIdLink = this.authData.autoStartUrl;
        } else {
            this.pollCollect = true;
            this.pollCollectRequest();
        }

        window.location.replace(bankIdLink);
    }

    otherDeviceAuth() {
        this.qrInProgress = true;
        this.qrCodePath = this.authData.qrImage || '';
        this.pollCollect = true;
        this.refreshQrCode();
        this.pollCollectRequest();
    }

    cancelQrLogin() {
        this.qrInProgress = false;
        this.pollCollect = false;
        this.qrCodePath = '';
        this.qrTimeStamp = 1;
    }

    refreshQrCode() {
        if (this.qrInProgress) {
            this.qrTimeStamp++;
            setTimeout(this.refreshQrCode, 5000);
        }
    }

    pollCollectRequest(afterAuth: boolean = false) {
        if (this.pollCollect) {
            const payload = {
                meetingId: this.authData.meetingId,
                organizationId: this.organizationId
            };
            const pollrequest = http.post('/api/bankid/collect', payload);
            pollrequest
                .then((response: any) => {
                    if (!response.ok) {
                        this.cancelQrLogin();
                        return;
                    }
                    response.json().then((data: TPollResponse) => {
                        if (data.status === 'complete') {
                            this.cancelQrLogin();
                            this.$emit('verificationCompleted');
                        } else if (data.status === 'pending') {
                            setTimeout(this.pollCollectRequest, 1000);
                        } else if (data.status === 'failed') {
                            this.showError = true;
                            this.cancelQrLogin();
                        }
                    });
                })
                .catch((e: any) => {
                    this.cancelQrLogin();
                    this.showError = true;
                    console.error(e);
                });
        }
    }

    get returnUrl() {
        if (window.location.href.indexOf('meetingId') > -1) {
            return window.location.href;
        } else if (window.location.href.indexOf('?') === -1) {
            return `${window.location.href}?meetingId=${this.bookingId}`;
        } else {
            return `${window.location.href}&meetingId=${this.bookingId}`;
        }
    }

    get logoPath() {
        return this.culture === 'nb-NO' ? '/ui/assets/BankID_no_logo.svg' : `/ui/assets/BankID_se_logo.svg`;
    }

    get qrCodePathWithTimeStamp() {
        return `${this.qrCodePath}?${this.qrTimeStamp}`;
    }
}
